<template>
  <div class="grid justify-content-center">
    <div class="col-12 md:col-6">
      <div class="card my-4 text-center">
        <div>
          <router-link to="/">
            <img
              class=""
              src="images/logo.png"
              alt="logo"
              style="height: 56px"
            />
          </router-link>
        </div>
        <div class="text-xl font-bold text-green-600 mt-3">
          {{ $t("your_password_has_been_changed_successfully") }}
        </div>
        <hr />
        <router-link to="/">
          <Button class="p-button-text" :label="$t('click_here_to_login')" />
        </router-link>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {},
  data: function () {
    return {};
  },
  methods: {},
};
</script>
